module.exports = __webpack_public_path__ + "static/media/flagSpain.7b38c27f.svg";